import * as React from 'react';
import styled from 'styled-components';
import { InputError } from './InputError';

type InputType =
  | 'text'
  | 'tel'
  | 'email'
  | 'password'
  | 'checkbox'
  | 'textarea'
  | 'submit'
  | undefined;

export interface IInput {
  nybygg?: boolean;
  type?: InputType;
  name?: string;
  label?: string;
  labelAfter?: string;
  placeholder?: string;
  value?: string | number;
  error?: boolean;
  errorMessage?: string;
  forwardRef?: any;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  onFocus?: (e: any) => void;
}

export const Input: React.FC<IInput> = React.memo(
  React.forwardRef((props, ref) => {
    return (
      <StyledInputWrapper>
        {props.label ? (
          <label>
            {props.label}{' '}
            {props.labelAfter ? <span>{props.labelAfter}</span> : null}
          </label>
        ) : null}
        {props.error && props.errorMessage ? (
          <InputError>{props.errorMessage}</InputError>
        ) : null}
        <StyledInput
          ref={ref}
          className={props.nybygg ? 'nybygg' : ''}
          type={props.type}
          name={props.name}
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          error={props.error}
        />
      </StyledInputWrapper>
    );
  })
);

const StyledInputWrapper = styled.div`
  width: 100%;

  label {
    display: block;
    color: ${(props) => props.theme.input.label};
    margin-bottom: 10px;

    span {
      color: ${(props) => props.theme.input.labelAfter};
    }
  }
`;

const StyledInput: any = styled.input`
  display: block;
  padding: 15px;
  width: 100%;
  background: ${(props: any) => props.theme.input.background} !important;
  font-family: inherit;
  font-size: 16px !important;
  font-weight: 400 !important;
  color: white;
  border: ${(props: any) =>
    props.error
      ? `solid 2px ${props.theme.input.error}`
      : 'solid 2px transparent'};
  outline: none;
  border-radius: 0;
  appearance: none;

  &[type='submit'] {
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${(props: any) => props.theme.input.placeholder} !important;
  }

  &.nybygg {
    background: rgb(255, 255, 255);
    color: rgb(0, 0, 0);

    &::placeholder {
      color: rgb(0, 0, 0);
    }
  }
`;
